// The pushState event changes the URL in the \routing\redux\listeners.js file, but we still need
// to reload the page when the browser's back/forward buttons are clicked. That is done here.
window.addEventListener("popstate", () => {
  window.location.reload();
});
